"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _icons = require("@material-ui/icons");
var _colors = _interopRequireDefault(require("@fe/ui/colors"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const spinnerStyles = {
  container: {
    display: 'flex',
    height: '100vh',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    width: '25%',
    minWidth: 300,
    height: '25%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'column'
  }
};
const Spinner = ({
  classes,
  message,
  title = 'Something went wrong'
}) => /*#__PURE__*/_react.default.createElement("div", {
  className: classes.container
}, /*#__PURE__*/_react.default.createElement(_Paper.default, {
  className: classes.paper
}, /*#__PURE__*/_react.default.createElement(_Typography.default, {
  variant: "h4",
  style: {
    display: 'flex',
    alignItems: 'center'
  }
}, /*#__PURE__*/_react.default.createElement(_icons.Error, {
  style: {
    color: _colors.default.error
  },
  fontSize: "large"
}), ' ', title), /*#__PURE__*/_react.default.createElement(_Typography.default, {
  variant: "h5"
}, message)));
var _default = exports.default = (0, _withStyles.default)(spinnerStyles)(Spinner);